import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "资讯", to: "/news" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        transparent
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur border-b border-background-200"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-xl text-background-50"></i>
            </span>
            <span
              className={`font-heading font-bold text-lg tracking-tight transition-colors ${
                transparent ? "text-background-50" : "text-foreground-950"
              }`}
            >
              蘑菇<span className="text-primary-500">TV</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? "text-primary-500"
                      : transparent
                        ? "text-background-100 hover:text-background-50"
                        : "text-foreground-700 hover:text-primary-500"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={submitSearch}
              className="hidden lg:flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-3 py-1.5"
            >
              <i className="ri-search-line text-foreground-500 text-base"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视 / 资讯"
                className="bg-transparent outline-none text-sm text-foreground-950 placeholder:text-foreground-500 w-40"
              />
              <button
                type="submit"
                className="text-xs font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
              >
                搜索
              </button>
            </form>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开菜单"
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
                transparent ? "text-background-50" : "text-foreground-950"
              }`}
            >
              <i className={menuOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <form
            onSubmit={submitSearch}
            className="flex items-center gap-2 bg-background-100 border border-background-200 rounded-full px-4 py-2 mb-4"
          >
            <i className="ri-search-line text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视 / 资讯"
              className="bg-transparent outline-none text-sm flex-1 text-foreground-950 placeholder:text-foreground-500"
            />
            <button
              type="submit"
              className="text-sm font-medium text-primary-600 whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `py-3 px-2 rounded-md text-base font-medium border-b border-background-200 last:border-0 ${
                    isActive ? "text-primary-500" : "text-foreground-800"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}